import hovTooltipIcon from 'assets/HeartOfVegas/tooltip-icon.png';
import cmcTooltipIcon from 'assets/cashman/cmc-tooltip.png';
import { CSSProperties } from 'react';
import { LightningLinkSaleBadge } from 'components/Badge/Sale/LightningLinkSaleBadge';
import { HeartOfVegasSaleBadge } from 'components/Badge/Sale/HeartOfVegasSaleBadge';
import { MightyFuSaleBadge } from 'components/Badge/Sale/MightyFuSaleBadge';
import { CashManCasinoSaleBadge } from 'components/Badge/Sale/CashManCasinoSaleBadge';

const TOOLTIP_ICON =
  'https://media-dev.appcharge.com/media/6683d66f3ad9e626ecc051f5/1724936979813__75209c47-b991-4515-a23b-c3bd7ed7fa2a';

export enum EDynamicBundleType {
  LLC = 'llc',
  CMC = 'cmc',
  HOV = 'hov',
  MFC = 'mfc',
}

export const LLC_TOOLTIP_ICON = TOOLTIP_ICON;
export const HOV_TOOLTIP_ICON = hovTooltipIcon;
export const CMC_TOOLTIP_ICON = cmcTooltipIcon;
export const MFC_TOOLTIP_ICON = TOOLTIP_ICON;

export const PL_DYNAMIC_TOOLTIP_ICONS = {
  [EDynamicBundleType.LLC]: LLC_TOOLTIP_ICON,
  [EDynamicBundleType.HOV]: HOV_TOOLTIP_ICON,
  [EDynamicBundleType.CMC]: CMC_TOOLTIP_ICON,
  [EDynamicBundleType.MFC]: MFC_TOOLTIP_ICON,
} as const;

export const SaleBadge = {
  [EDynamicBundleType.LLC]: LightningLinkSaleBadge,
  [EDynamicBundleType.HOV]: HeartOfVegasSaleBadge,
  [EDynamicBundleType.CMC]: CashManCasinoSaleBadge,
  [EDynamicBundleType.MFC]: MightyFuSaleBadge,
} as const;

export const MAIN_PRODUCT_TOOLTIP_BUTTON_STYLES: CSSProperties = {
  height: '16px',
  width: '16px',
  zIndex: 2,
  cursor: 'pointer',
  marginLeft: '4px',
};

export const SUB_PRODUCT_TOOLTIP_BUTTON_STYLES: Record<
  EDynamicBundleType,
  CSSProperties
> = {
  [EDynamicBundleType.LLC]: {
    position: 'absolute',
    right: '2px',
    top: '2px',
    height: '16px',
    zIndex: 2,
    cursor: 'pointer',
  },
  [EDynamicBundleType.HOV]: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '16px',
    zIndex: 2,
    cursor: 'pointer',
  },
  [EDynamicBundleType.CMC]: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '16px',
    zIndex: 2,
    cursor: 'pointer',
  },
  [EDynamicBundleType.MFC]: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '16px',
    zIndex: 2,
    cursor: 'pointer',
  },
};

export const ADVANCED_TOOLTIP_STYLES: Record<
  EDynamicBundleType,
  CSSProperties
> = {
  [EDynamicBundleType.LLC]: {
    background: '#3E2893',
    minWidth: 160,
    borderRadius: '7px',
    zIndex: '5',
    padding: '8px',
  },
  [EDynamicBundleType.HOV]: {
    background: '#6f48d8',
    minWidth: 160,
    borderRadius: '7px',
    zIndex: '5',
    padding: '8px',
  },
  [EDynamicBundleType.CMC]: {
    background: 'linear-gradient(180deg, #E952B5 0%, #D735B3 100%)',
    minWidth: 160,
    borderRadius: '7px',
    zIndex: '5',
    padding: '8px',
  },
  [EDynamicBundleType.MFC]: {
    background: '#023B50',
    minWidth: 160,
    borderRadius: '7px',
    zIndex: '5',
    padding: '8px',
  },
};

export const SIMPLE_TOOLTIP_STYLES: Record<EDynamicBundleType, CSSProperties> = {
  [EDynamicBundleType.LLC]: {
    background: '#3E2893',
    color: '#ffff',
    maxWidth: 220,
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '1.5',
    zIndex: '5',
  },
  [EDynamicBundleType.HOV]: {
    background: '#6f48d8',
    color: '#4F018A',
    maxWidth: 220,
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '1.5',
    zIndex: '5',
  },
  [EDynamicBundleType.CMC]: {
    background: 'linear-gradient(180deg, #E952B5 0%, #D735B3 100%)',
    color: '#4F018A',
    maxWidth: 220,
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '1.5',
    zIndex: '5',
  },
  [EDynamicBundleType.MFC]: {
    background: '#023B50',
    color: '#ffff',
    maxWidth: 220,
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '1.5',
    zIndex: '5',
  },
};
